import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SidebarMenu from "./components/common/SidebarMenu";
import HomePage from "./pages/HomePage";
import PandL from "./pages/PnL";
import Extras from "./pages/Extras";
import PandLTabs from "./pages/PnLTabs";
import VAR from "./pages/VAR";
import KFactors from "./pages/KFactors";
import Credit from "./pages/Credit";
import RiskDashboard from "./pages/RiskDashboard";

import Scorecard from "./pages/Scorecard";
import CreditDashboard from "./pages/CreditDashboard";
import PreKFactorsPage from "./pages/PreKFactorsPage";
import MarketRisk from "./pages/MarketRisk";
import MarketRiskVAR from "./pages/MarketRiskVAR";
import PositionsPositions from "./pages/PositionsPositions";
import GlossaryPage from "./pages/Glossary";
import FundingRisk from "./pages/FundingRisk";

const App: React.FC = () => {
  return (
    <Router>
      <SidebarMenu />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/performance/P&L" element={<PandL />} />
        {/*<Route path="/tabs" element={<PandLTabs />} />*/}
        <Route path="/pre-trade/var" element={<VAR />} />
        <Route path="/compliance/kfactors" element={<KFactors />} />
        <Route path="/positions" element={<PositionsPositions/>} />
        <Route path="/credit-risk/credit" element={<Credit />} />
        <Route path="/risk-dashboard" element={<RiskDashboard />} />
        <Route path="/market-risk" element={<MarketRisk/>} />
        <Route path="/funding-risk" element={<FundingRisk/>} />
        <Route path="/market-risk/VAR" element={<MarketRiskVAR/>} />
        <Route path="performance/scorecard" element={<Scorecard />} />
        <Route path="credit-risk/dashboard" element={<CreditDashboard />} />
        <Route path="pre-trade/k-factors" element={<PreKFactorsPage />} />
        <Route path="glossary" element={<GlossaryPage />} />
      </Routes>
    </Router>
  );
};

export default App;
